import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import {
    EFAmazon,
    EFApp,
    EFCapacity,
    EFCycle,
    EFDoubleLight,
    EFJD,
    EFLBS,
    EFLFP,
    EFOutput,
    EFOutput2,
    EFPort,
    EFPort1,
    EFPort2,
    EFPort3,
    EFRakuten,
    EFShopify,
    EFStream,
    EFWarranty,
    EFWarranty1,
} from '@/components/UI/svg/river2';
import EFFully from '@/components/UI/svg/river2/Icon/EFFully';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { Select } from 'antd';
import React from 'react';
import css from './index.module.scss';
import { getProductInfo } from '@/utils/hooks/useProductInfo';

const { EFPic } = createEFPic('/media/river2/h5/');
export default function M() {
    const { useEffect, useState, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'za', 'au', 'ph']);

    useEffect(() => {
        const productsInit = [
            { ...river2pro, btns: linkMap3[locale]?.river2pro?.btns },
            { ...river2max, btns: linkMap3[locale]?.river2max?.btns },
            { ...river2, btns: linkMap3[locale]?.river2?.btns },
        ];
        setProducts(productsInit);
        setProductsAll(productsInit);
    }, []);

    // 第三个时间段
    const linkMap3: any = {
        cn: {
            river2: {
                btns: [{ icon: <EFJD />, link: 'https://item.jd.com/10023368540908.html', text: t('river2.details.sec4_btn_jd'), type: 'JD' }],
            },
            river2max: {
                btns: [{ icon: <EFJD />, link: 'https://item.jd.com/10023352057072.html', text: t('river2.details.sec4_btn_jd'), type: 'JD' }],
            },
            river2pro: {
                btns: [{ icon: <EFJD />, link: 'https://item.jd.com/10060944419352.html', text: t('river2.details.sec4_btn_jd'), type: 'JD' }],
            },
        },
        us: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://us.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://us.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://us.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        za: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://za.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://za.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        au: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://au.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://au.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        ca: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ca.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ca.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        eu: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        uk: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://uk.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://uk.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://uk.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        de: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://de.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://de.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://de.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        fr: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://fr.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://fr.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://fr.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        it: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://it.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://it.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://it.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        es: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://es.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://es.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://es.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        jp: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://jp.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://jp.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://jp.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        cis: {
            river2: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-max',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-pro',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        sa: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://www.amazon.ae/dp/B0BFQC1CNQ?ref=myi_title_dp',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://www.amazon.ae/dp/B0BFQB86ZL?ref=myi_title_dp',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: '',
                        link: '',
                        text: t('river2.details.sec4_btn_soon'),
                        theme: 'default',
                        type: 'soon',
                    },
                ],
            },
        },
        ph: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ph.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ph.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ph.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
    };

    const river2: any = {
        cls: 'river2',
        img:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751081751280/1.png'
                : [`M_river2_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `M_river2_${locale === 'sa' ? 'uk' : imgSpec}.png`],
        productName: t('river2.details.sec13_river2'),
        productPrice: t.rich('river2.details.sec13_river2_price', {
            p1: (child: React.ReactNode) => <span>{child}</span>,
        }),
        productId: (() => {
            const ids = {
                ph: '9451541430582',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        variantId: (() => {
            const ids = {
                ph: '49116496757046',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        btns: [{ icon: <EFAmazon />, text: t('river2.details.sec13_amazon'), theme: 'white' }],
        icons: [
            { icon: <EFCapacity />, text: t('river2.details.sec13_list1_icon1_text') },
            { icon: <EFFully />, text: t('river2.details.sec13_list1_icon2_text') },
            { icon: locale === 'ph' ? <EFOutput2 /> : <EFOutput />, text: t('river2.details.sec13_list1_icon3_text') },
            { icon: <EFStream />, text: t('river2.details.sec13_list1_icon4_text'), type: 'xboost' },
            { icon: <EFLBS />, text: t('river2.details.sec13_list1_icon5_text') },
            { icon: locale === 'ph' ? <EFPort1 /> : <EFPort />, text: t('river2.details.sec13_list1_icon6_text'), type: 'port' },
            { icon: <EFDoubleLight />, text: t('river2.details.sec13_list1_icon7_text') },
            { icon: <EFLFP />, text: t('river2.details.sec13_list1_icon8_text') },
            { icon: <EFCycle />, text: t('river2.details.sec13_list1_icon9_text') },
            { icon: locale === 'ph' ? <EFWarranty1 /> : <EFWarranty />, text: t('river2.details.sec13_list1_icon10_text') },
            { icon: <EFApp />, text: t('river2.details.sec13_list1_icon11_text') },
        ],
    };
    const river2max: any = {
        cls: 'river2Max',
        img:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751081751483/2.png'
                : [`M_river2_max_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `M_river2_max_${locale === 'sa' ? 'uk' : imgSpec}.png`],
        productName: t('river2.details.sec13_river2_max'),
        productPrice: t.rich('river2.details.sec13_river2_max_price', {
            p1: (child: React.ReactNode) => <span>{child}</span>,
        }),
        productId: (() => {
            const ids = {
                ph: '9451541561654',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        variantId: (() => {
            const ids = {
                ph: '51432344518966',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        btns: [{ icon: <EFRakuten />, text: t('river2.details.sec13_shopify'), theme: 'white', type: 'rakuten' }],
        icons: [
            { icon: <EFCapacity />, text: t('river2.details.sec13_list2_icon1_text') },
            { icon: <EFFully />, text: t('river2.details.sec13_list1_icon2_text') },
            { icon: locale === 'ph' ? <EFOutput2 /> : <EFOutput />, text: t('river2.details.sec13_list2_icon3_text') },
            { icon: <EFStream />, text: t('river2.details.sec13_list2_icon4_text'), type: 'xboost' },
            { icon: <EFLBS />, text: t('river2.details.sec13_list2_icon5_text') },
            { icon: locale === 'ph' ? <EFPort2 /> : <EFPort />, text: t('river2.details.sec13_list2_icon6_text'), type: 'port' },
            { icon: <EFDoubleLight />, text: t('river2.details.sec13_list2_icon7_text') },
            { icon: <EFLFP />, text: t('river2.details.sec13_list2_icon8_text') },
            { icon: <EFCycle />, text: t('river2.details.sec13_list2_icon9_text') },
            { icon: locale === 'ph' ? <EFWarranty1 /> : <EFWarranty />, text: t('river2.details.sec13_list2_icon10_text') },
            { icon: <EFApp />, text: t('river2.details.sec13_list2_icon11_text') },
        ],
    };
    const river2pro: any = {
        cls: 'river2Pro',
        img:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751081751673/3.png'
                : [`M_river2_pro_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `M_river2_pro_${locale === 'sa' ? 'uk' : imgSpec}.png`],
        productName: t('river2.details.sec13_river2_pro'),
        productPrice: t.rich('river2.details.sec13_river2_pro_price', {
            p1: (child: React.ReactNode) => <span>{child}</span>,
        }),
        productId: (() => {
            const ids = {
                ph: '9451541627190',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        variantId: (() => {
            const ids = {
                ph: '49116498067766',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        btns: [{ icon: '', text: t('river2.details.sec13_coming'), theme: 'default' }],
        icons: [
            { icon: <EFCapacity />, text: t('river2.details.sec13_list3_icon1_text') },
            { icon: <EFFully />, text: t('river2.details.sec13_list3_icon2_text') },
            { icon: locale === 'ph' ? <EFOutput2 /> : <EFOutput />, text: t('river2.details.sec13_list3_icon3_text') },
            { icon: <EFStream />, text: t('river2.details.sec13_list3_icon4_text'), type: 'xboost' },
            { icon: <EFLBS />, text: t('river2.details.sec13_list3_icon5_text') },
            { icon: locale === 'ph' ? <EFPort3 /> : <EFPort />, text: t('river2.details.sec13_list3_icon6_text'), type: 'port' },
            { icon: <EFDoubleLight />, text: t('river2.details.sec13_list3_icon7_text') },
            { icon: <EFLFP />, text: t('river2.details.sec13_list3_icon8_text') },
            { icon: <EFCycle />, text: t('river2.details.sec13_list3_icon9_text') },
            { icon: locale === 'ph' ? <EFWarranty1 /> : <EFWarranty />, text: t('river2.details.sec13_list3_icon10_text') },
            { icon: <EFApp />, text: t('river2.details.sec13_list3_icon11_text') },
        ],
    };

    const [products, setProducts] = useState([river2pro, river2]);
    const [productsAll, setProductsAll] = useState([river2pro, river2, river2max]);

    const onLink = (link: string, type: string, cls: string, signup = false) => {
        if (signup) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return;
        }
        try {
            // fb埋点
            if (type === 'amazon') {
                window?.fbq('track', 'AddToWishlist');
            }
            if (type === 'rakuten') {
                window?.fbq('track', 'donate');
            }
            if (type === 'store') {
                window?.fbq('track', 'Search');
            }
            if (type === 'notify') {
                window?.fbq('track', 'Contact');
            }
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: `buy_on_${['store', 'amazon', 'notify'].includes(type) ? (type === 'notify' ? 'store' : type) : 'other'}`,
                button_name:
                    type === 'notify'
                        ? 'Notify Me'
                        : `Buy on ${
                              type === 'amazon'
                                  ? 'Amazon'
                                  : type === 'JD'
                                  ? 'JD'
                                  : ['notify', 'store'].includes(type)
                                  ? 'Ecoflow Store'
                                  : type === 'rakuten'
                                  ? 'Rakuten'
                                  : 'Other'
                          }`,
                product_name: cls === 'river2' ? 'RIVER 2' : cls === 'river2Max' ? 'RIVER 2 Max' : 'RIVER 2 Pro',
                list_name: 'Bottom Product List',
            });
        } catch (e) {
            console.log(e);
        } finally {
            window.location.href = link;
        }
    };

    const [leftValue, setLeftValue] = useState(river2pro?.productName);
    const [rightValue, setRightValue] = useState(river2max?.productName);
    const [lastLeftValue, setLastLeftValue] = useState('');
    const [lastRightValue, setLastRightValue] = useState('');

    const onChangeProduct = (v: string, k: number) => {
        if ((k === 0 && leftValue === v) || (k === 1 && rightValue === v)) {
            return;
        }
        if (k === 0) {
            if (v === rightValue) {
                setRightValue(lastRightValue ? lastRightValue : v === river2.productName ? river2max.productName : river2.productName);
                setLastRightValue(rightValue);
                setProducts([
                    productsAll?.find((item: any) => item.productName === v),
                    productsAll?.find(
                        (item: any) =>
                            item.productName === (lastRightValue ? lastRightValue : v === river2.productName ? river2max.productName : river2.productName),
                    ),
                ]);
            } else {
                setProducts([productsAll?.find((item: any) => item.productName === v), productsAll?.find((item: any) => item.productName === rightValue)]);
            }
            setLeftValue(v);
            setLastLeftValue(leftValue);
        }
        if (k === 1) {
            if (v === leftValue) {
                setLeftValue(lastLeftValue ? lastLeftValue : v === river2.productName ? river2max.productName : river2.productName);
                setLastLeftValue(leftValue);
                setProducts([
                    productsAll?.find(
                        (item: any) =>
                            item.productName === (lastLeftValue ? lastLeftValue : v === river2.productName ? river2max.productName : river2.productName),
                    ),
                    productsAll?.find((item: any) => item.productName === v),
                ]);
            } else {
                setProducts([productsAll?.find((item: any) => item.productName === leftValue), productsAll?.find((item: any) => item.productName === v)]);
            }
            setRightValue(v);
            setLastRightValue(rightValue);
        }
    };

    useEffect(() => {
        if (locale !== 'ph') return; // ph 读取价格
        const run = async () => {
            const data = await getProductInfo([river2, river2max, river2pro], locale);
            data.forEach((i, idx) => {
                if (!i.price) return;
                if (idx === 0) return (river2.productPrice = i.price);
                if (idx === 1) return (river2max.productPrice = i.price);
                if (idx === 2) return (river2pro.productPrice = i.price);
            });
        };
        run();
        setProducts([river2pro, river2]);
    }, [locale]);

    return (
        <section className={`river2_details_M ${css.M_13}`} key="river2h5m">
            <div className={`innerBox`}>
                <div className="textBox">
                    <p className="title">{t('river2.details.sec13_title')}</p>
                </div>
                <div className="productsViewBox">
                    <ul className="productLists">
                        {products?.slice(0, 2)?.map((product: any, k: number) => (
                            <li className="productList" key={k}>
                                <div className={`upperBox upperBox_${k}`}>
                                    <Select
                                        getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                        value={k === 0 ? leftValue : rightValue}
                                        onChange={(v: string) => onChangeProduct(v, k)}
                                        suffixIcon={
                                            <span
                                                style={{
                                                    display: 'block',
                                                    transform: 'rotate(0deg)',
                                                }}
                                            >
                                                <EFArrowDown style={{ fontSize: '0.15rem' }} />
                                            </span>
                                        }
                                    >
                                        <Select.Option
                                            className={`optionItem ${
                                                (k === 0 && leftValue === river2.productName) || (k === 1 && rightValue === river2.productName)
                                                    ? 'activeItem'
                                                    : ''
                                            }`}
                                            value={river2.productName}
                                            title={river2.productName}
                                        >
                                            {river2.productName}
                                        </Select.Option>
                                        <Select.Option
                                            className={`optionItem ${
                                                (k === 0 && leftValue === river2max.productName) || (k === 1 && rightValue === river2max.productName)
                                                    ? 'activeItem'
                                                    : ''
                                            }`}
                                            value={river2max.productName}
                                            title={river2max.productName}
                                        >
                                            {river2max.productName}
                                        </Select.Option>
                                        <Select.Option
                                            className={`optionItem ${
                                                (k === 0 && leftValue === river2pro.productName) || (k === 1 && rightValue === river2pro.productName)
                                                    ? 'activeItem'
                                                    : ''
                                            }`}
                                            value={river2pro.productName}
                                            title={river2pro.productName}
                                        >
                                            {river2pro.productName}
                                        </Select.Option>
                                    </Select>
                                </div>
                                <div className="supperBox">
                                    <div className={`imgBox ${product?.cls}`}>
                                        {locale === 'ph' ? (
                                            <img src={product?.img} alt={product?.productName} aria-label={product?.productName} />
                                        ) : (
                                            <EFPic name={product?.img} alt={product?.productName} aria-label={product?.productName} />
                                        )}
                                    </div>
                                    {!['sa'].includes(locale) && <div className="price">{product?.productPrice}</div>}
                                    <ul className="btns">
                                        {product?.btns?.map((btn: any, m: number) => (
                                            <li className={`btn ${btn?.theme}`} key={m}>
                                                {btn?.link && (
                                                    <div className="link" onClick={() => onLink(btn?.link, btn?.type, product?.cls, btn?.signup)}>
                                                        {btn?.icon && <div className={`btnIcon ${btn?.type}`}>{btn?.icon}</div>}
                                                        <div className="textOuter">
                                                            <div className="btnText">{btn?.text}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                {!btn?.link && (
                                                    <span className="btnIconBox">
                                                        {btn?.icon && <div className={`btnIcon ${btn?.type}`}>{btn?.icon}</div>}
                                                        <div className="textOuter">
                                                            <div className="btnText">{btn?.text}</div>
                                                        </div>
                                                    </span>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                    <ul className="icons">
                                        {product?.icons?.map((icon: any, n: number) => (
                                            <li className="icon" key={n}>
                                                {icon?.icon && <div className={`iconIcon ${icon?.type}`}>{icon?.icon}</div>}
                                                {icon?.img && (
                                                    <div className={`iconIcon ${icon?.type}`}>
                                                        <Image src={icon?.img} layout="fill" />
                                                    </div>
                                                )}

                                                <div className="iconText">{icon?.text}</div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
